// Auto-generated from ../../notes/moh-inference/enhanced/*.csv.
// Regenerate by running scripts/build-enhanced-coverage.py.
// Do not edit by hand.

export interface EnhancedStructureRow {
  ds_class: string;
  structure_code: string;
  ds_group: string;
  db_category_group: string;
  studies_pct: number;
  videos_pct: number;
  frames_pct_any: number;
  frames_pct_conf05: number;
  mean_score: number | null;
  det_per_frame: number | null;
  best_sweep: number | null;
  best_sweep_pct: number | null;
  total_detections: number;
}

export interface EnhancedTrimesterRow {
  ds_class: string;
  structure_code: string;
  t1_lt14w_pct: number;
  t2_14_28w_pct: number;
  t3_ge28w_pct: number;
}

export interface EnhancedFacilityRow {
  ds_class: string;
  structure_code: string;
  csr1_boutferda: number;
  csr2_aghbala: number;
  csr2_anergui: number;
  csr2_ait_tamlil: number;
  csr2_moulay_bouazza: number;
  csu_el_ksiba: number;
}

export const ENHANCED_COHORT = {
  studies: 213,
  studies_registered: 218,
  videos: 1251,
  frames: 237014,
  facilities: 6,
  trimester_n: { t1: 28, t2: 72, t3: 106, unknown: 7 },
  facility_n: {
    csr1_boutferda: 10,
    csr2_aghbala: 92,
    csr2_anergui: 13,
    csr2_ait_tamlil: 7,
    csr2_moulay_bouazza: 42,
    csu_el_ksiba: 49,
  },
  facility_labels: {
    csr1_boutferda: 'CSR1 Boutferda',
    csr2_aghbala: 'CSR2 Aghbala',
    csr2_anergui: 'CSR2 Anergui',
    csr2_ait_tamlil: 'CSR2 A\u00eft Tamlil',
    csr2_moulay_bouazza: 'CSR2 Moulay Bouazza',
    csu_el_ksiba: 'CSU El Ksiba',
  },
} as const;

export const ENHANCED_STRUCTURES: EnhancedStructureRow[] = [
  {
    "ds_class": "af_pocket_segmentation",
    "structure_code": "amniotic_fluid",
    "ds_group": "Amniotic Fluid / Placenta",
    "db_category_group": "environment",
    "studies_pct": 98.12,
    "videos_pct": 98.88,
    "frames_pct_any": 59.9851,
    "frames_pct_conf05": 23.2193,
    "mean_score": 0.37,
    "det_per_frame": 1.98,
    "best_sweep": 3,
    "best_sweep_pct": 100.0,
    "total_detections": 292651
  },
  {
    "ds_class": "femur_segment",
    "structure_code": "femur",
    "ds_group": "Limbs",
    "db_category_group": "biometry",
    "studies_pct": 87.79,
    "videos_pct": 68.11,
    "frames_pct_any": 4.2394,
    "frames_pct_conf05": 0.4312,
    "mean_score": 0.308,
    "det_per_frame": 1.2,
    "best_sweep": 6,
    "best_sweep_pct": 81.5,
    "total_detections": 13719
  },
  {
    "ds_class": "placenta_polygon",
    "structure_code": "placenta",
    "ds_group": "Amniotic Fluid / Placenta",
    "db_category_group": "environment",
    "studies_pct": 87.32,
    "videos_pct": 91.77,
    "frames_pct_any": 56.1494,
    "frames_pct_conf05": 27.1326,
    "mean_score": 0.415,
    "det_per_frame": 1.79,
    "best_sweep": 5,
    "best_sweep_pct": 98.8,
    "total_detections": 234016
  },
  {
    "ds_class": "cephalic_plane_ellipse_segment",
    "structure_code": "fetal_brain",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 86.85,
    "videos_pct": 83.61,
    "frames_pct_any": 11.7765,
    "frames_pct_conf05": 5.5026,
    "mean_score": 0.506,
    "det_per_frame": 1.1,
    "best_sweep": 7,
    "best_sweep_pct": 90.8,
    "total_detections": 30551
  },
  {
    "ds_class": "fetal_spine_segment_polygon",
    "structure_code": "fetal_spine",
    "ds_group": "Spine",
    "db_category_group": "spine",
    "studies_pct": 85.92,
    "videos_pct": 80.26,
    "frames_pct_any": 6.2422,
    "frames_pct_conf05": 1.3307,
    "mean_score": 0.346,
    "det_per_frame": 1.26,
    "best_sweep": 6,
    "best_sweep_pct": 93.0,
    "total_detections": 18859
  },
  {
    "ds_class": "maternal_bladder",
    "structure_code": "maternal_bladder",
    "ds_group": "Amniotic Fluid / Placenta",
    "db_category_group": "maternal",
    "studies_pct": 84.04,
    "videos_pct": 67.95,
    "frames_pct_any": 2.656,
    "frames_pct_conf05": 0.6687,
    "mean_score": 0.371,
    "det_per_frame": 1.15,
    "best_sweep": 7,
    "best_sweep_pct": 80.3,
    "total_detections": 7446
  },
  {
    "ds_class": "hand_box",
    "structure_code": "hand",
    "ds_group": "Limbs",
    "db_category_group": "extremities",
    "studies_pct": 82.16,
    "videos_pct": 59.79,
    "frames_pct_any": 2.2362,
    "frames_pct_conf05": 0.1958,
    "mean_score": 0.309,
    "det_per_frame": 1.09,
    "best_sweep": 6,
    "best_sweep_pct": 74.5,
    "total_detections": 5884
  },
  {
    "ds_class": "heart_segment",
    "structure_code": "heart",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 81.22,
    "videos_pct": 61.47,
    "frames_pct_any": 4.2158,
    "frames_pct_conf05": 1.651,
    "mean_score": 0.443,
    "det_per_frame": 1.1,
    "best_sweep": 6,
    "best_sweep_pct": 73.2,
    "total_detections": 11159
  },
  {
    "ds_class": "ribs_box_segment",
    "structure_code": "ribs",
    "ds_group": "Thorax",
    "db_category_group": "thoracic",
    "studies_pct": 81.22,
    "videos_pct": 67.39,
    "frames_pct_any": 6.4384,
    "frames_pct_conf05": 2.0653,
    "mean_score": 0.363,
    "det_per_frame": 1.51,
    "best_sweep": 6,
    "best_sweep_pct": 82.8,
    "total_detections": 25284
  },
  {
    "ds_class": "fetal_bladder_segment_polygon",
    "structure_code": "fetal_bladder",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "abdominal",
    "studies_pct": 80.28,
    "videos_pct": 52.52,
    "frames_pct_any": 1.891,
    "frames_pct_conf05": 0.6114,
    "mean_score": 0.417,
    "det_per_frame": 1.09,
    "best_sweep": 5,
    "best_sweep_pct": 56.8,
    "total_detections": 4936
  },
  {
    "ds_class": "umbilical_cord_segment",
    "structure_code": "umbilical_cord",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "environment",
    "studies_pct": 79.81,
    "videos_pct": 60.51,
    "frames_pct_any": 4.02,
    "frames_pct_conf05": 0.9451,
    "mean_score": 0.363,
    "det_per_frame": 1.19,
    "best_sweep": 6,
    "best_sweep_pct": 75.2,
    "total_detections": 12019
  },
  {
    "ds_class": "femur_extremities_box_segment",
    "structure_code": "femur_extremity",
    "ds_group": "Limbs",
    "db_category_group": "extremities",
    "studies_pct": 79.34,
    "videos_pct": 44.44,
    "frames_pct_any": 1.1881,
    "frames_pct_conf05": 0.0709,
    "mean_score": 0.256,
    "det_per_frame": 2.16,
    "best_sweep": 6,
    "best_sweep_pct": 54.8,
    "total_detections": 6971
  },
  {
    "ds_class": "abdominal_biometry_plane_ellipse_segment",
    "structure_code": "abdomen",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "biometry",
    "studies_pct": 78.87,
    "videos_pct": 44.52,
    "frames_pct_any": 1.9868,
    "frames_pct_conf05": 0.4434,
    "mean_score": 0.381,
    "det_per_frame": 1.03,
    "best_sweep": 5,
    "best_sweep_pct": 50.0,
    "total_detections": 4868
  },
  {
    "ds_class": "lungs_segment_polygon",
    "structure_code": "lungs",
    "ds_group": "Thorax",
    "db_category_group": "thoracic",
    "studies_pct": 77.0,
    "videos_pct": 48.28,
    "frames_pct_any": 2.618,
    "frames_pct_conf05": 0.6962,
    "mean_score": 0.38,
    "det_per_frame": 1.19,
    "best_sweep": 6,
    "best_sweep_pct": 60.5,
    "total_detections": 8032
  },
  {
    "ds_class": "orbit_segment",
    "structure_code": "orbit",
    "ds_group": "Neuro / Head",
    "db_category_group": "face",
    "studies_pct": 77.0,
    "videos_pct": 60.43,
    "frames_pct_any": 2.5066,
    "frames_pct_conf05": 0.4544,
    "mean_score": 0.327,
    "det_per_frame": 1.28,
    "best_sweep": 7,
    "best_sweep_pct": 70.4,
    "total_detections": 7860
  },
  {
    "ds_class": "stomach_bubble_segment",
    "structure_code": "stomach_bubble",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "abdominal",
    "studies_pct": 73.24,
    "videos_pct": 41.89,
    "frames_pct_any": 1.7227,
    "frames_pct_conf05": 0.7586,
    "mean_score": 0.471,
    "det_per_frame": 1.04,
    "best_sweep": 6,
    "best_sweep_pct": 52.2,
    "total_detections": 4312
  },
  {
    "ds_class": "choroid_plexus",
    "structure_code": "choroid_plexus",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 72.77,
    "videos_pct": 39.17,
    "frames_pct_any": 1.8328,
    "frames_pct_conf05": 0.4852,
    "mean_score": 0.328,
    "det_per_frame": 1.71,
    "best_sweep": 7,
    "best_sweep_pct": 55.9,
    "total_detections": 8584
  },
  {
    "ds_class": "nasal_bone_box_segment",
    "structure_code": "nasal_bone",
    "ds_group": "Neuro / Head",
    "db_category_group": "face",
    "studies_pct": 66.2,
    "videos_pct": 32.13,
    "frames_pct_any": 0.7371,
    "frames_pct_conf05": 0.0211,
    "mean_score": 0.269,
    "det_per_frame": 1.19,
    "best_sweep": 7,
    "best_sweep_pct": 40.1,
    "total_detections": 2164
  },
  {
    "ds_class": "aorta_segment",
    "structure_code": "aorta",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 65.73,
    "videos_pct": 30.62,
    "frames_pct_any": 1.1168,
    "frames_pct_conf05": 0.1996,
    "mean_score": 0.334,
    "det_per_frame": 1.19,
    "best_sweep": 3,
    "best_sweep_pct": 37.6,
    "total_detections": 3277
  },
  {
    "ds_class": "ventricle_segment",
    "structure_code": "ventricle",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 62.91,
    "videos_pct": 25.58,
    "frames_pct_any": 0.5447,
    "frames_pct_conf05": 0.0506,
    "mean_score": 0.295,
    "det_per_frame": 1.32,
    "best_sweep": 7,
    "best_sweep_pct": 32.2,
    "total_detections": 1844
  },
  {
    "ds_class": "arm_humerus_segment_polygon",
    "structure_code": "arm_humerus",
    "ds_group": "Limbs",
    "db_category_group": "extremities",
    "studies_pct": 59.62,
    "videos_pct": 22.14,
    "frames_pct_any": 0.3793,
    "frames_pct_conf05": 0.0392,
    "mean_score": 0.314,
    "det_per_frame": 1.09,
    "best_sweep": 6,
    "best_sweep_pct": 29.9,
    "total_detections": 1007
  },
  {
    "ds_class": "fetal_kidneys_segment_polygon",
    "structure_code": "fetal_kidneys",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "abdominal",
    "studies_pct": 58.22,
    "videos_pct": 21.82,
    "frames_pct_any": 0.7122,
    "frames_pct_conf05": 0.1413,
    "mean_score": 0.346,
    "det_per_frame": 1.17,
    "best_sweep": 5,
    "best_sweep_pct": 30.2,
    "total_detections": 2074
  },
  {
    "ds_class": "cervix_polygon",
    "structure_code": "cervix",
    "ds_group": "Amniotic Fluid / Placenta",
    "db_category_group": "maternal",
    "studies_pct": 56.34,
    "videos_pct": 15.91,
    "frames_pct_any": 0.1911,
    "frames_pct_conf05": 0.0131,
    "mean_score": 0.296,
    "det_per_frame": 1.08,
    "best_sweep": 7,
    "best_sweep_pct": 22.4,
    "total_detections": 519
  },
  {
    "ds_class": "umbilical_vein_segment_polygon",
    "structure_code": "umbilical_vein",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "environment",
    "studies_pct": 55.87,
    "videos_pct": 18.47,
    "frames_pct_any": 0.4198,
    "frames_pct_conf05": 0.0532,
    "mean_score": 0.315,
    "det_per_frame": 1.24,
    "best_sweep": 5,
    "best_sweep_pct": 24.7,
    "total_detections": 1247
  },
  {
    "ds_class": "forearm_bones_segment_polygon",
    "structure_code": "forearm_bones",
    "ds_group": "Limbs",
    "db_category_group": "extremities",
    "studies_pct": 53.99,
    "videos_pct": 20.22,
    "frames_pct_any": 0.4021,
    "frames_pct_conf05": 0.0295,
    "mean_score": 0.305,
    "det_per_frame": 1.08,
    "best_sweep": 1,
    "best_sweep_pct": 24.9,
    "total_detections": 1071
  },
  {
    "ds_class": "cerebral_peduncle",
    "structure_code": "cerebral_peduncle",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 52.11,
    "videos_pct": 17.99,
    "frames_pct_any": 0.613,
    "frames_pct_conf05": 0.1443,
    "mean_score": 0.339,
    "det_per_frame": 2.07,
    "best_sweep": 3,
    "best_sweep_pct": 27.5,
    "total_detections": 3330
  },
  {
    "ds_class": "cerebellum_segment_polygon",
    "structure_code": "cerebellum",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 48.83,
    "videos_pct": 14.63,
    "frames_pct_any": 0.2612,
    "frames_pct_conf05": 0.0253,
    "mean_score": 0.305,
    "det_per_frame": 1.09,
    "best_sweep": 3,
    "best_sweep_pct": 21.7,
    "total_detections": 680
  },
  {
    "ds_class": "genitalia_segment",
    "structure_code": "genitalia",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "abdominal",
    "studies_pct": 47.42,
    "videos_pct": 12.95,
    "frames_pct_any": 0.1215,
    "frames_pct_conf05": 0.0025,
    "mean_score": 0.269,
    "det_per_frame": 1.13,
    "best_sweep": 6,
    "best_sweep_pct": 15.9,
    "total_detections": 320
  },
  {
    "ds_class": "hard_palate_box_segment",
    "structure_code": "hard_palate",
    "ds_group": "Neuro / Head",
    "db_category_group": "face",
    "studies_pct": 43.66,
    "videos_pct": 14.55,
    "frames_pct_any": 0.3084,
    "frames_pct_conf05": 0.0114,
    "mean_score": 0.282,
    "det_per_frame": 1.03,
    "best_sweep": 6,
    "best_sweep_pct": 24.2,
    "total_detections": 766
  },
  {
    "ds_class": "sylvian_fissure_box_segment",
    "structure_code": "sylvian_fissure",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 37.56,
    "videos_pct": 11.59,
    "frames_pct_any": 0.3726,
    "frames_pct_conf05": 0.0709,
    "mean_score": 0.335,
    "det_per_frame": 1.18,
    "best_sweep": 3,
    "best_sweep_pct": 19.6,
    "total_detections": 1082
  },
  {
    "ds_class": "thalamus_segment",
    "structure_code": "thalamus",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 37.56,
    "videos_pct": 11.51,
    "frames_pct_any": 0.3865,
    "frames_pct_conf05": 0.0878,
    "mean_score": 0.367,
    "det_per_frame": 1.27,
    "best_sweep": 3,
    "best_sweep_pct": 16.9,
    "total_detections": 1295
  },
  {
    "ds_class": "portal_sinus_segment",
    "structure_code": "portal_sinus",
    "ds_group": "Abdomen / Renal / GI",
    "db_category_group": "abdominal",
    "studies_pct": 32.86,
    "videos_pct": 8.39,
    "frames_pct_any": 0.1388,
    "frames_pct_conf05": 0.0055,
    "mean_score": 0.281,
    "det_per_frame": 1.07,
    "best_sweep": 3,
    "best_sweep_pct": 10.6,
    "total_detections": 381
  },
  {
    "ds_class": "right_atrium_segment",
    "structure_code": "right_atrium",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 32.39,
    "videos_pct": 9.83,
    "frames_pct_any": 0.2983,
    "frames_pct_conf05": 0.0848,
    "mean_score": 0.394,
    "det_per_frame": 1.05,
    "best_sweep": 3,
    "best_sweep_pct": 12.7,
    "total_detections": 766
  },
  {
    "ds_class": "leg_bones_segment_polygon",
    "structure_code": "leg_bones",
    "ds_group": "Limbs",
    "db_category_group": "extremities",
    "studies_pct": 31.92,
    "videos_pct": 9.51,
    "frames_pct_any": 0.151,
    "frames_pct_conf05": 0.0042,
    "mean_score": 0.284,
    "det_per_frame": 1.21,
    "best_sweep": 1,
    "best_sweep_pct": 12.2,
    "total_detections": 482
  },
  {
    "ds_class": "mandible_box_segment",
    "structure_code": "mandible",
    "ds_group": "Neuro / Head",
    "db_category_group": "face",
    "studies_pct": 31.92,
    "videos_pct": 8.87,
    "frames_pct_any": 0.1245,
    "frames_pct_conf05": 0.0017,
    "mean_score": 0.251,
    "det_per_frame": 1.18,
    "best_sweep": 7,
    "best_sweep_pct": 12.5,
    "total_detections": 339
  },
  {
    "ds_class": "right_ventricle_segment",
    "structure_code": "right_ventricle",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 31.92,
    "videos_pct": 8.47,
    "frames_pct_any": 0.2253,
    "frames_pct_conf05": 0.0156,
    "mean_score": 0.299,
    "det_per_frame": 1.14,
    "best_sweep": 6,
    "best_sweep_pct": 12.7,
    "total_detections": 653
  },
  {
    "ds_class": "left_ventricle_segment",
    "structure_code": "left_ventricle",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 31.46,
    "videos_pct": 9.19,
    "frames_pct_any": 0.2367,
    "frames_pct_conf05": 0.016,
    "mean_score": 0.298,
    "det_per_frame": 1.2,
    "best_sweep": 6,
    "best_sweep_pct": 15.9,
    "total_detections": 734
  },
  {
    "ds_class": "inferior_vena_cava_polygon_segment",
    "structure_code": "inferior_vena_cava",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 27.7,
    "videos_pct": 6.08,
    "frames_pct_any": 0.0941,
    "frames_pct_conf05": 0.0025,
    "mean_score": 0.293,
    "det_per_frame": 1.01,
    "best_sweep": 5,
    "best_sweep_pct": 9.9,
    "total_detections": 225
  },
  {
    "ds_class": "foot_box_segment",
    "structure_code": "foot",
    "ds_group": "Limbs",
    "db_category_group": "extremities",
    "studies_pct": 26.76,
    "videos_pct": 6.79,
    "frames_pct_any": 0.0747,
    "frames_pct_conf05": 0.0013,
    "mean_score": 0.267,
    "det_per_frame": 1.08,
    "best_sweep": 6,
    "best_sweep_pct": 10.8,
    "total_detections": 215
  },
  {
    "ds_class": "cisterna_magna_segment",
    "structure_code": "cisterna_magna",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 22.07,
    "videos_pct": 4.48,
    "frames_pct_any": 0.0595,
    "frames_pct_conf05": 0.0034,
    "mean_score": 0.281,
    "det_per_frame": 1.11,
    "best_sweep": 3,
    "best_sweep_pct": 10.1,
    "total_detections": 160
  },
  {
    "ds_class": "left_atrium_segment",
    "structure_code": "left_atrium",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 22.07,
    "videos_pct": 5.2,
    "frames_pct_any": 0.1224,
    "frames_pct_conf05": 0.0118,
    "mean_score": 0.29,
    "det_per_frame": 1.31,
    "best_sweep": 4,
    "best_sweep_pct": 7.6,
    "total_detections": 425
  },
  {
    "ds_class": "cavum_septum_pellucidum_segment_polygon",
    "structure_code": "cavum_septum_pellucidum",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 20.19,
    "videos_pct": 4.64,
    "frames_pct_any": 0.0751,
    "frames_pct_conf05": 0.008,
    "mean_score": 0.328,
    "det_per_frame": 1.04,
    "best_sweep": 3,
    "best_sweep_pct": 9.5,
    "total_detections": 184
  },
  {
    "ds_class": "myometrium polygon",
    "structure_code": "myometrium",
    "ds_group": "Amniotic Fluid / Placenta",
    "db_category_group": "maternal",
    "studies_pct": 13.62,
    "videos_pct": 2.96,
    "frames_pct_any": 0.0257,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.247,
    "det_per_frame": 1.03,
    "best_sweep": 7,
    "best_sweep_pct": 7.2,
    "total_detections": 62
  },
  {
    "ds_class": "inter_atrial_septum_segment",
    "structure_code": "inter_atrial_septum",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 12.21,
    "videos_pct": 2.64,
    "frames_pct_any": 0.038,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.241,
    "det_per_frame": 1.2,
    "best_sweep": 6,
    "best_sweep_pct": 3.8,
    "total_detections": 103
  },
  {
    "ds_class": "interventricular_septum_segment",
    "structure_code": "interventricular_septum",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 12.21,
    "videos_pct": 2.56,
    "frames_pct_any": 0.0422,
    "frames_pct_conf05": 0.0004,
    "mean_score": 0.264,
    "det_per_frame": 1.12,
    "best_sweep": 3,
    "best_sweep_pct": 4.2,
    "total_detections": 112
  },
  {
    "ds_class": "hippocampal_gyri_box_segment",
    "structure_code": "hippocampal_gyri",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 10.8,
    "videos_pct": 2.08,
    "frames_pct_any": 0.043,
    "frames_pct_conf05": 0.0013,
    "mean_score": 0.255,
    "det_per_frame": 1.65,
    "best_sweep": 3,
    "best_sweep_pct": 6.3,
    "total_detections": 194
  },
  {
    "ds_class": "pulmonary_artery_segment",
    "structure_code": "pulmonary_artery",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 7.51,
    "videos_pct": 1.44,
    "frames_pct_any": 0.0122,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.26,
    "det_per_frame": 1.0,
    "best_sweep": 4,
    "best_sweep_pct": 2.7,
    "total_detections": 29
  },
  {
    "ds_class": "superior_vena_cava_segment",
    "structure_code": "superior_vena_cava",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 5.63,
    "videos_pct": 1.04,
    "frames_pct_any": 0.011,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.252,
    "det_per_frame": 1.07,
    "best_sweep": 4,
    "best_sweep_pct": 2.2,
    "total_detections": 30
  },
  {
    "ds_class": "fetal_segmentation",
    "structure_code": "fetal_segmentation",
    "ds_group": "Whole Body",
    "db_category_group": "abdomen",
    "studies_pct": 4.23,
    "videos_pct": 0.8,
    "frames_pct_any": 0.0072,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.268,
    "det_per_frame": 1.0,
    "best_sweep": 3,
    "best_sweep_pct": 1.6,
    "total_detections": 17
  },
  {
    "ds_class": "mitral_valve_box_segment",
    "structure_code": "mitral_valve",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 4.23,
    "videos_pct": 0.88,
    "frames_pct_any": 0.0135,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.243,
    "det_per_frame": 1.32,
    "best_sweep": 4,
    "best_sweep_pct": 2.7,
    "total_detections": 45
  },
  {
    "ds_class": "tricuspid_valve_box_segment",
    "structure_code": "tricuspid_valve",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 4.23,
    "videos_pct": 0.8,
    "frames_pct_any": 0.0063,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.239,
    "det_per_frame": 1.3,
    "best_sweep": 1,
    "best_sweep_pct": 1.4,
    "total_detections": 20
  },
  {
    "ds_class": "nuchal_translucency_polygon_segment",
    "structure_code": "nuchal_translucency",
    "ds_group": "Neuro / Head",
    "db_category_group": "biometry",
    "studies_pct": 1.88,
    "videos_pct": 0.32,
    "frames_pct_any": 0.003,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.256,
    "det_per_frame": 1.0,
    "best_sweep": 2,
    "best_sweep_pct": 1.6,
    "total_detections": 7
  },
  {
    "ds_class": "foramen_ovale_box_segment",
    "structure_code": "foramen_ovale",
    "ds_group": "Cardiac",
    "db_category_group": "cardiac",
    "studies_pct": 1.41,
    "videos_pct": 0.24,
    "frames_pct_any": 0.0013,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.26,
    "det_per_frame": 1.0,
    "best_sweep": 4,
    "best_sweep_pct": 1.1,
    "total_detections": 3
  },
  {
    "ds_class": "vermis_segment",
    "structure_code": "vermis",
    "ds_group": "Neuro / Head",
    "db_category_group": "brain",
    "studies_pct": 1.41,
    "videos_pct": 0.24,
    "frames_pct_any": 0.0017,
    "frames_pct_conf05": 0.0,
    "mean_score": 0.25,
    "det_per_frame": 1.17,
    "best_sweep": 3,
    "best_sweep_pct": 1.1,
    "total_detections": 5
  },
  {
    "ds_class": "cephalic_pole_for_crl_box_segment",
    "structure_code": "cephalic_pole_for_crl",
    "ds_group": "Neuro / Head",
    "db_category_group": "biometry",
    "studies_pct": 0.0,
    "videos_pct": 0.0,
    "frames_pct_any": 0.0,
    "frames_pct_conf05": 0.0,
    "mean_score": null,
    "det_per_frame": null,
    "best_sweep": null,
    "best_sweep_pct": null,
    "total_detections": 0
  },
  {
    "ds_class": "rump_pole_for_crl_box_segment",
    "structure_code": "rump_pole_for_crl",
    "ds_group": "Whole Body",
    "db_category_group": "biometry",
    "studies_pct": 0.0,
    "videos_pct": 0.0,
    "frames_pct_any": 0.0,
    "frames_pct_conf05": 0.0,
    "mean_score": null,
    "det_per_frame": null,
    "best_sweep": null,
    "best_sweep_pct": null,
    "total_detections": 0
  }
];

export const ENHANCED_TRIMESTER: EnhancedTrimesterRow[] = [
  {
    "ds_class": "af_pocket_segmentation",
    "structure_code": "amniotic_fluid",
    "t1_lt14w_pct": 100.0,
    "t2_14_28w_pct": 98.6,
    "t3_ge28w_pct": 98.1
  },
  {
    "ds_class": "femur_segment",
    "structure_code": "femur",
    "t1_lt14w_pct": 21.4,
    "t2_14_28w_pct": 97.2,
    "t3_ge28w_pct": 98.1
  },
  {
    "ds_class": "placenta_polygon",
    "structure_code": "placenta",
    "t1_lt14w_pct": 21.4,
    "t2_14_28w_pct": 98.6,
    "t3_ge28w_pct": 97.2
  },
  {
    "ds_class": "cephalic_plane_ellipse_segment",
    "structure_code": "fetal_brain",
    "t1_lt14w_pct": 21.4,
    "t2_14_28w_pct": 98.6,
    "t3_ge28w_pct": 97.2
  },
  {
    "ds_class": "fetal_spine_segment_polygon",
    "structure_code": "fetal_spine",
    "t1_lt14w_pct": 21.4,
    "t2_14_28w_pct": 97.2,
    "t3_ge28w_pct": 95.3
  },
  {
    "ds_class": "maternal_bladder",
    "structure_code": "maternal_bladder",
    "t1_lt14w_pct": 21.4,
    "t2_14_28w_pct": 93.1,
    "t3_ge28w_pct": 94.3
  },
  {
    "ds_class": "hand_box",
    "structure_code": "hand",
    "t1_lt14w_pct": 21.4,
    "t2_14_28w_pct": 94.4,
    "t3_ge28w_pct": 91.5
  },
  {
    "ds_class": "heart_segment",
    "structure_code": "heart",
    "t1_lt14w_pct": 17.9,
    "t2_14_28w_pct": 94.4,
    "t3_ge28w_pct": 90.6
  },
  {
    "ds_class": "ribs_box_segment",
    "structure_code": "ribs",
    "t1_lt14w_pct": 10.7,
    "t2_14_28w_pct": 94.4,
    "t3_ge28w_pct": 92.5
  },
  {
    "ds_class": "fetal_bladder_segment_polygon",
    "structure_code": "fetal_bladder",
    "t1_lt14w_pct": 21.4,
    "t2_14_28w_pct": 90.3,
    "t3_ge28w_pct": 90.6
  },
  {
    "ds_class": "umbilical_cord_segment",
    "structure_code": "umbilical_cord",
    "t1_lt14w_pct": 7.1,
    "t2_14_28w_pct": 97.2,
    "t3_ge28w_pct": 88.7
  },
  {
    "ds_class": "femur_extremities_box_segment",
    "structure_code": "femur_extremity",
    "t1_lt14w_pct": 17.9,
    "t2_14_28w_pct": 86.1,
    "t3_ge28w_pct": 92.5
  },
  {
    "ds_class": "abdominal_biometry_plane_ellipse_segment",
    "structure_code": "abdomen",
    "t1_lt14w_pct": 14.3,
    "t2_14_28w_pct": 91.7,
    "t3_ge28w_pct": 88.7
  },
  {
    "ds_class": "lungs_segment_polygon",
    "structure_code": "lungs",
    "t1_lt14w_pct": 7.1,
    "t2_14_28w_pct": 84.7,
    "t3_ge28w_pct": 90.6
  },
  {
    "ds_class": "orbit_segment",
    "structure_code": "orbit",
    "t1_lt14w_pct": 7.1,
    "t2_14_28w_pct": 86.1,
    "t3_ge28w_pct": 91.5
  },
  {
    "ds_class": "stomach_bubble_segment",
    "structure_code": "stomach_bubble",
    "t1_lt14w_pct": 17.9,
    "t2_14_28w_pct": 75.0,
    "t3_ge28w_pct": 87.7
  },
  {
    "ds_class": "choroid_plexus",
    "structure_code": "choroid_plexus",
    "t1_lt14w_pct": 7.1,
    "t2_14_28w_pct": 84.7,
    "t3_ge28w_pct": 83.0
  },
  {
    "ds_class": "nasal_bone_box_segment",
    "structure_code": "nasal_bone",
    "t1_lt14w_pct": 3.6,
    "t2_14_28w_pct": 75.0,
    "t3_ge28w_pct": 78.3
  },
  {
    "ds_class": "aorta_segment",
    "structure_code": "aorta",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 65.3,
    "t3_ge28w_pct": 84.0
  },
  {
    "ds_class": "ventricle_segment",
    "structure_code": "ventricle",
    "t1_lt14w_pct": 7.1,
    "t2_14_28w_pct": 76.4,
    "t3_ge28w_pct": 68.9
  },
  {
    "ds_class": "arm_humerus_segment_polygon",
    "structure_code": "arm_humerus",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 70.8,
    "t3_ge28w_pct": 68.9
  },
  {
    "ds_class": "fetal_kidneys_segment_polygon",
    "structure_code": "fetal_kidneys",
    "t1_lt14w_pct": 3.6,
    "t2_14_28w_pct": 56.9,
    "t3_ge28w_pct": 75.5
  },
  {
    "ds_class": "cervix_polygon",
    "structure_code": "cervix",
    "t1_lt14w_pct": 17.9,
    "t2_14_28w_pct": 72.2,
    "t3_ge28w_pct": 56.6
  },
  {
    "ds_class": "umbilical_vein_segment_polygon",
    "structure_code": "umbilical_vein",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 54.2,
    "t3_ge28w_pct": 73.6
  },
  {
    "ds_class": "forearm_bones_segment_polygon",
    "structure_code": "forearm_bones",
    "t1_lt14w_pct": 3.6,
    "t2_14_28w_pct": 75.0,
    "t3_ge28w_pct": 54.7
  },
  {
    "ds_class": "cerebral_peduncle",
    "structure_code": "cerebral_peduncle",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 48.6,
    "t3_ge28w_pct": 69.8
  },
  {
    "ds_class": "cerebellum_segment_polygon",
    "structure_code": "cerebellum",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 58.3,
    "t3_ge28w_pct": 56.6
  },
  {
    "ds_class": "genitalia_segment",
    "structure_code": "genitalia",
    "t1_lt14w_pct": 7.1,
    "t2_14_28w_pct": 58.3,
    "t3_ge28w_pct": 52.8
  },
  {
    "ds_class": "hard_palate_box_segment",
    "structure_code": "hard_palate",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 52.8,
    "t3_ge28w_pct": 50.0
  },
  {
    "ds_class": "sylvian_fissure_box_segment",
    "structure_code": "sylvian_fissure",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 43.1,
    "t3_ge28w_pct": 45.3
  },
  {
    "ds_class": "thalamus_segment",
    "structure_code": "thalamus",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 47.2,
    "t3_ge28w_pct": 42.5
  },
  {
    "ds_class": "portal_sinus_segment",
    "structure_code": "portal_sinus",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 30.6,
    "t3_ge28w_pct": 43.4
  },
  {
    "ds_class": "right_atrium_segment",
    "structure_code": "right_atrium",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 31.9,
    "t3_ge28w_pct": 40.6
  },
  {
    "ds_class": "leg_bones_segment_polygon",
    "structure_code": "leg_bones",
    "t1_lt14w_pct": 10.7,
    "t2_14_28w_pct": 51.4,
    "t3_ge28w_pct": 24.5
  },
  {
    "ds_class": "mandible_box_segment",
    "structure_code": "mandible",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 40.3,
    "t3_ge28w_pct": 36.8
  },
  {
    "ds_class": "right_ventricle_segment",
    "structure_code": "right_ventricle",
    "t1_lt14w_pct": 3.6,
    "t2_14_28w_pct": 33.3,
    "t3_ge28w_pct": 39.6
  },
  {
    "ds_class": "left_ventricle_segment",
    "structure_code": "left_ventricle",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 31.9,
    "t3_ge28w_pct": 39.6
  },
  {
    "ds_class": "inferior_vena_cava_polygon_segment",
    "structure_code": "inferior_vena_cava",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 22.2,
    "t3_ge28w_pct": 39.6
  },
  {
    "ds_class": "foot_box_segment",
    "structure_code": "foot",
    "t1_lt14w_pct": 3.6,
    "t2_14_28w_pct": 55.6,
    "t3_ge28w_pct": 14.2
  },
  {
    "ds_class": "cisterna_magna_segment",
    "structure_code": "cisterna_magna",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 27.8,
    "t3_ge28w_pct": 23.6
  },
  {
    "ds_class": "left_atrium_segment",
    "structure_code": "left_atrium",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 20.8,
    "t3_ge28w_pct": 29.2
  },
  {
    "ds_class": "cavum_septum_pellucidum_segment_polygon",
    "structure_code": "cavum_septum_pellucidum",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 16.7,
    "t3_ge28w_pct": 28.3
  },
  {
    "ds_class": "myometrium polygon",
    "structure_code": "myometrium",
    "t1_lt14w_pct": 14.3,
    "t2_14_28w_pct": 23.6,
    "t3_ge28w_pct": 6.6
  },
  {
    "ds_class": "inter_atrial_septum_segment",
    "structure_code": "inter_atrial_septum",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 5.6,
    "t3_ge28w_pct": 20.8
  },
  {
    "ds_class": "interventricular_septum_segment",
    "structure_code": "interventricular_septum",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 12.5,
    "t3_ge28w_pct": 16.0
  },
  {
    "ds_class": "hippocampal_gyri_box_segment",
    "structure_code": "hippocampal_gyri",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 11.1,
    "t3_ge28w_pct": 13.2
  },
  {
    "ds_class": "pulmonary_artery_segment",
    "structure_code": "pulmonary_artery",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 4.2,
    "t3_ge28w_pct": 12.3
  },
  {
    "ds_class": "superior_vena_cava_segment",
    "structure_code": "superior_vena_cava",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 2.8,
    "t3_ge28w_pct": 9.4
  },
  {
    "ds_class": "fetal_segmentation",
    "structure_code": "fetal_segmentation",
    "t1_lt14w_pct": 7.1,
    "t2_14_28w_pct": 6.9,
    "t3_ge28w_pct": 0.9
  },
  {
    "ds_class": "mitral_valve_box_segment",
    "structure_code": "mitral_valve",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 6.9,
    "t3_ge28w_pct": 3.8
  },
  {
    "ds_class": "tricuspid_valve_box_segment",
    "structure_code": "tricuspid_valve",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 2.8,
    "t3_ge28w_pct": 6.6
  },
  {
    "ds_class": "nuchal_translucency_polygon_segment",
    "structure_code": "nuchal_translucency",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 0.0,
    "t3_ge28w_pct": 3.8
  },
  {
    "ds_class": "foramen_ovale_box_segment",
    "structure_code": "foramen_ovale",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 0.0,
    "t3_ge28w_pct": 2.8
  },
  {
    "ds_class": "vermis_segment",
    "structure_code": "vermis",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 2.8,
    "t3_ge28w_pct": 0.0
  },
  {
    "ds_class": "cephalic_pole_for_crl_box_segment",
    "structure_code": "cephalic_pole_for_crl",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 0.0,
    "t3_ge28w_pct": 0.0
  },
  {
    "ds_class": "rump_pole_for_crl_box_segment",
    "structure_code": "rump_pole_for_crl",
    "t1_lt14w_pct": 0.0,
    "t2_14_28w_pct": 0.0,
    "t3_ge28w_pct": 0.0
  }
];

export const ENHANCED_FACILITY: EnhancedFacilityRow[] = [
  {
    "ds_class": "af_pocket_segmentation",
    "structure_code": "amniotic_fluid",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 98.9,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 100.0,
    "csu_el_ksiba": 95.9
  },
  {
    "ds_class": "femur_segment",
    "structure_code": "femur",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 72.8,
    "csr2_anergui": 100.0,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 100.0,
    "csu_el_ksiba": 98.0
  },
  {
    "ds_class": "placenta_polygon",
    "structure_code": "placenta",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 73.9,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 100.0,
    "csu_el_ksiba": 95.9
  },
  {
    "ds_class": "cephalic_plane_ellipse_segment",
    "structure_code": "fetal_brain",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 73.9,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 95.9
  },
  {
    "ds_class": "fetal_spine_segment_polygon",
    "structure_code": "fetal_spine",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 71.7,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 95.9
  },
  {
    "ds_class": "maternal_bladder",
    "structure_code": "maternal_bladder",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 69.6,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 95.2,
    "csu_el_ksiba": 95.9
  },
  {
    "ds_class": "hand_box",
    "structure_code": "hand",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 68.5,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 92.9,
    "csu_el_ksiba": 91.8
  },
  {
    "ds_class": "heart_segment",
    "structure_code": "heart",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 64.1,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 91.8
  },
  {
    "ds_class": "ribs_box_segment",
    "structure_code": "ribs",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 63.0,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 93.9
  },
  {
    "ds_class": "fetal_bladder_segment_polygon",
    "structure_code": "fetal_bladder",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 62.0,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 85.7,
    "csr2_moulay_bouazza": 95.2,
    "csu_el_ksiba": 95.9
  },
  {
    "ds_class": "umbilical_cord_segment",
    "structure_code": "umbilical_cord",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 64.1,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 85.7
  },
  {
    "ds_class": "femur_extremities_box_segment",
    "structure_code": "femur_extremity",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 64.1,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 85.7
  },
  {
    "ds_class": "abdominal_biometry_plane_ellipse_segment",
    "structure_code": "abdomen",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 58.7,
    "csr2_anergui": 76.9,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 95.9
  },
  {
    "ds_class": "lungs_segment_polygon",
    "structure_code": "lungs",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 54.3,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 85.7,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 93.9
  },
  {
    "ds_class": "orbit_segment",
    "structure_code": "orbit",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 58.7,
    "csr2_anergui": 92.3,
    "csr2_ait_tamlil": 85.7,
    "csr2_moulay_bouazza": 97.6,
    "csu_el_ksiba": 85.7
  },
  {
    "ds_class": "stomach_bubble_segment",
    "structure_code": "stomach_bubble",
    "csr1_boutferda": 100.0,
    "csr2_aghbala": 53.3,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 88.1,
    "csu_el_ksiba": 85.7
  },
  {
    "ds_class": "choroid_plexus",
    "structure_code": "choroid_plexus",
    "csr1_boutferda": 90.0,
    "csr2_aghbala": 53.3,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 90.5,
    "csu_el_ksiba": 83.7
  },
  {
    "ds_class": "nasal_bone_box_segment",
    "structure_code": "nasal_bone",
    "csr1_boutferda": 80.0,
    "csr2_aghbala": 45.7,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 85.7,
    "csr2_moulay_bouazza": 85.7,
    "csu_el_ksiba": 77.6
  },
  {
    "ds_class": "aorta_segment",
    "structure_code": "aorta",
    "csr1_boutferda": 70.0,
    "csr2_aghbala": 45.7,
    "csr2_anergui": 76.9,
    "csr2_ait_tamlil": 57.1,
    "csr2_moulay_bouazza": 95.2,
    "csu_el_ksiba": 75.5
  },
  {
    "ds_class": "ventricle_segment",
    "structure_code": "ventricle",
    "csr1_boutferda": 80.0,
    "csr2_aghbala": 47.8,
    "csr2_anergui": 84.6,
    "csr2_ait_tamlil": 100.0,
    "csr2_moulay_bouazza": 76.2,
    "csu_el_ksiba": 65.3
  },
  {
    "ds_class": "arm_humerus_segment_polygon",
    "structure_code": "arm_humerus",
    "csr1_boutferda": 60.0,
    "csr2_aghbala": 40.2,
    "csr2_anergui": 76.9,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 85.7,
    "csu_el_ksiba": 71.4
  },
  {
    "ds_class": "fetal_kidneys_segment_polygon",
    "structure_code": "fetal_kidneys",
    "csr1_boutferda": 60.0,
    "csr2_aghbala": 38.0,
    "csr2_anergui": 61.5,
    "csr2_ait_tamlil": 85.7,
    "csr2_moulay_bouazza": 81.0,
    "csu_el_ksiba": 71.4
  },
  {
    "ds_class": "cervix_polygon",
    "structure_code": "cervix",
    "csr1_boutferda": 60.0,
    "csr2_aghbala": 45.7,
    "csr2_anergui": 53.8,
    "csr2_ait_tamlil": 71.4,
    "csr2_moulay_bouazza": 64.3,
    "csu_el_ksiba": 67.3
  },
  {
    "ds_class": "umbilical_vein_segment_polygon",
    "structure_code": "umbilical_vein",
    "csr1_boutferda": 70.0,
    "csr2_aghbala": 40.2,
    "csr2_anergui": 61.5,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 88.1,
    "csu_el_ksiba": 55.1
  },
  {
    "ds_class": "forearm_bones_segment_polygon",
    "structure_code": "forearm_bones",
    "csr1_boutferda": 80.0,
    "csr2_aghbala": 34.8,
    "csr2_anergui": 69.2,
    "csr2_ait_tamlil": 71.4,
    "csr2_moulay_bouazza": 78.6,
    "csu_el_ksiba": 57.1
  },
  {
    "ds_class": "cerebral_peduncle",
    "structure_code": "cerebral_peduncle",
    "csr1_boutferda": 70.0,
    "csr2_aghbala": 35.9,
    "csr2_anergui": 76.9,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 76.2,
    "csu_el_ksiba": 53.1
  },
  {
    "ds_class": "cerebellum_segment_polygon",
    "structure_code": "cerebellum",
    "csr1_boutferda": 80.0,
    "csr2_aghbala": 32.6,
    "csr2_anergui": 61.5,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 73.8,
    "csu_el_ksiba": 49.0
  },
  {
    "ds_class": "genitalia_segment",
    "structure_code": "genitalia",
    "csr1_boutferda": 50.0,
    "csr2_aghbala": 39.1,
    "csr2_anergui": 53.8,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 71.4,
    "csu_el_ksiba": 40.8
  },
  {
    "ds_class": "hard_palate_box_segment",
    "structure_code": "hard_palate",
    "csr1_boutferda": 60.0,
    "csr2_aghbala": 32.6,
    "csr2_anergui": 76.9,
    "csr2_ait_tamlil": 57.1,
    "csr2_moulay_bouazza": 61.9,
    "csu_el_ksiba": 34.7
  },
  {
    "ds_class": "sylvian_fissure_box_segment",
    "structure_code": "sylvian_fissure",
    "csr1_boutferda": 40.0,
    "csr2_aghbala": 26.1,
    "csr2_anergui": 76.9,
    "csr2_ait_tamlil": 14.3,
    "csr2_moulay_bouazza": 59.5,
    "csu_el_ksiba": 32.7
  },
  {
    "ds_class": "thalamus_segment",
    "structure_code": "thalamus",
    "csr1_boutferda": 50.0,
    "csr2_aghbala": 29.3,
    "csr2_anergui": 69.2,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 57.1,
    "csu_el_ksiba": 30.6
  },
  {
    "ds_class": "portal_sinus_segment",
    "structure_code": "portal_sinus",
    "csr1_boutferda": 50.0,
    "csr2_aghbala": 19.6,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 47.6,
    "csu_el_ksiba": 38.8
  },
  {
    "ds_class": "right_atrium_segment",
    "structure_code": "right_atrium",
    "csr1_boutferda": 60.0,
    "csr2_aghbala": 20.7,
    "csr2_anergui": 61.5,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 50.0,
    "csu_el_ksiba": 24.5
  },
  {
    "ds_class": "leg_bones_segment_polygon",
    "structure_code": "leg_bones",
    "csr1_boutferda": 40.0,
    "csr2_aghbala": 29.3,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 50.0,
    "csu_el_ksiba": 16.3
  },
  {
    "ds_class": "mandible_box_segment",
    "structure_code": "mandible",
    "csr1_boutferda": 50.0,
    "csr2_aghbala": 22.8,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 33.3,
    "csu_el_ksiba": 40.8
  },
  {
    "ds_class": "right_ventricle_segment",
    "structure_code": "right_ventricle",
    "csr1_boutferda": 40.0,
    "csr2_aghbala": 22.8,
    "csr2_anergui": 61.5,
    "csr2_ait_tamlil": 28.6,
    "csr2_moulay_bouazza": 52.4,
    "csu_el_ksiba": 22.4
  },
  {
    "ds_class": "left_ventricle_segment",
    "structure_code": "left_ventricle",
    "csr1_boutferda": 60.0,
    "csr2_aghbala": 20.7,
    "csr2_anergui": 61.5,
    "csr2_ait_tamlil": 28.6,
    "csr2_moulay_bouazza": 47.6,
    "csu_el_ksiba": 24.5
  },
  {
    "ds_class": "inferior_vena_cava_polygon_segment",
    "structure_code": "inferior_vena_cava",
    "csr1_boutferda": 30.0,
    "csr2_aghbala": 19.6,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 14.3,
    "csr2_moulay_bouazza": 42.9,
    "csu_el_ksiba": 28.6
  },
  {
    "ds_class": "foot_box_segment",
    "structure_code": "foot",
    "csr1_boutferda": 40.0,
    "csr2_aghbala": 23.9,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 14.3,
    "csr2_moulay_bouazza": 38.1,
    "csu_el_ksiba": 18.4
  },
  {
    "ds_class": "cisterna_magna_segment",
    "structure_code": "cisterna_magna",
    "csr1_boutferda": 40.0,
    "csr2_aghbala": 17.4,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 57.1,
    "csr2_moulay_bouazza": 33.3,
    "csu_el_ksiba": 8.2
  },
  {
    "ds_class": "left_atrium_segment",
    "structure_code": "left_atrium",
    "csr1_boutferda": 30.0,
    "csr2_aghbala": 16.3,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 14.3,
    "csr2_moulay_bouazza": 35.7,
    "csu_el_ksiba": 16.3
  },
  {
    "ds_class": "cavum_septum_pellucidum_segment_polygon",
    "structure_code": "cavum_septum_pellucidum",
    "csr1_boutferda": 30.0,
    "csr2_aghbala": 16.3,
    "csr2_anergui": 15.4,
    "csr2_ait_tamlil": 14.3,
    "csr2_moulay_bouazza": 35.7,
    "csu_el_ksiba": 14.3
  },
  {
    "ds_class": "myometrium polygon",
    "structure_code": "myometrium",
    "csr1_boutferda": 10.0,
    "csr2_aghbala": 14.1,
    "csr2_anergui": 23.1,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 19.0,
    "csu_el_ksiba": 2.0
  },
  {
    "ds_class": "inter_atrial_septum_segment",
    "structure_code": "inter_atrial_septum",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 7.6,
    "csr2_anergui": 7.7,
    "csr2_ait_tamlil": 14.3,
    "csr2_moulay_bouazza": 26.2,
    "csu_el_ksiba": 12.2
  },
  {
    "ds_class": "interventricular_septum_segment",
    "structure_code": "interventricular_septum",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 10.9,
    "csr2_anergui": 23.1,
    "csr2_ait_tamlil": 14.3,
    "csr2_moulay_bouazza": 23.8,
    "csu_el_ksiba": 4.1
  },
  {
    "ds_class": "hippocampal_gyri_box_segment",
    "structure_code": "hippocampal_gyri",
    "csr1_boutferda": 30.0,
    "csr2_aghbala": 12.0,
    "csr2_anergui": 30.8,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 7.1,
    "csu_el_ksiba": 4.1
  },
  {
    "ds_class": "pulmonary_artery_segment",
    "structure_code": "pulmonary_artery",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 4.3,
    "csr2_anergui": 38.5,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 11.9,
    "csu_el_ksiba": 4.1
  },
  {
    "ds_class": "superior_vena_cava_segment",
    "structure_code": "superior_vena_cava",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 4.3,
    "csr2_anergui": 7.7,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 11.9,
    "csu_el_ksiba": 4.1
  },
  {
    "ds_class": "fetal_segmentation",
    "structure_code": "fetal_segmentation",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 4.3,
    "csr2_anergui": 7.7,
    "csr2_ait_tamlil": 42.9,
    "csr2_moulay_bouazza": 0.0,
    "csu_el_ksiba": 2.0
  },
  {
    "ds_class": "mitral_valve_box_segment",
    "structure_code": "mitral_valve",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 3.3,
    "csr2_anergui": 7.7,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 9.5,
    "csu_el_ksiba": 2.0
  },
  {
    "ds_class": "tricuspid_valve_box_segment",
    "structure_code": "tricuspid_valve",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 3.3,
    "csr2_anergui": 0.0,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 9.5,
    "csu_el_ksiba": 4.1
  },
  {
    "ds_class": "nuchal_translucency_polygon_segment",
    "structure_code": "nuchal_translucency",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 0.0,
    "csr2_anergui": 0.0,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 7.1,
    "csu_el_ksiba": 2.0
  },
  {
    "ds_class": "foramen_ovale_box_segment",
    "structure_code": "foramen_ovale",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 1.1,
    "csr2_anergui": 0.0,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 2.4,
    "csu_el_ksiba": 2.0
  },
  {
    "ds_class": "vermis_segment",
    "structure_code": "vermis",
    "csr1_boutferda": 10.0,
    "csr2_aghbala": 2.2,
    "csr2_anergui": 0.0,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 0.0,
    "csu_el_ksiba": 0.0
  },
  {
    "ds_class": "cephalic_pole_for_crl_box_segment",
    "structure_code": "cephalic_pole_for_crl",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 0.0,
    "csr2_anergui": 0.0,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 0.0,
    "csu_el_ksiba": 0.0
  },
  {
    "ds_class": "rump_pole_for_crl_box_segment",
    "structure_code": "rump_pole_for_crl",
    "csr1_boutferda": 0.0,
    "csr2_aghbala": 0.0,
    "csr2_anergui": 0.0,
    "csr2_ait_tamlil": 0.0,
    "csr2_moulay_bouazza": 0.0,
    "csu_el_ksiba": 0.0
  }
];
